import { useMemo } from "react";
import { TimeSlotItem } from "../WaitlistRequest.helpers";

export function useGenerateTimeSlotItems(rowIndex: number): TimeSlotItem[] {
    const time = useMemo(() => {
        return Array.from({ length: 7 }, (_, i) => ({
            key: i,
            value: 1 << (rowIndex + i * 3),
            isWeekDay: i < 5,
            isChecked: false,
        }));
    }, [rowIndex]);

    return time;
}
